import { call, takeEvery } from "redux-saga/effects";
import { uploadErrorLogsApi } from "../../api/SessionServiceManager";
import { types } from "../actions";

function* ErrorSaga() {
    yield takeEvery(types.ERROR_LOG_UPLOAD, uploadErrorLogs);
  }

function* uploadErrorLogs({payload}) {
    if (payload) {
        yield call(uploadErrorLogsApi, payload);
    }
}
export default ErrorSaga;